<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<c-form-item type="input" label="违禁词" name="words"></c-form-item>
					<c-form-item type="checkbox" label="状态" name="state" :options="state"></c-form-item>
				</c-form>
			</m-search>
			
			<m-operate>
				<c-button color="sys" power="b_prohibited_words_edit"  @click="batchAddProhibitedWords()">新增违禁词</c-button>
                <c-button power="b_prohibited_words_edit" @click="editWordState(2)" color="m" >批量启用</c-button>
                <c-button power="b_prohibited_words_edit" @click="editWordState(1)" color="red">批量禁用</c-button>
			</m-operate>
			
			<c-table ref="table" code="word_list">
                <c-table-column type="selector"></c-table-column>

				<c-table-column
					label="违禁词"
					name="words"
                    width="200"
				></c-table-column>
				
				<c-table-column
					label="状态"
					name="state"
					width="60"
				>
					<template v-slot="{data}">
						<span v-if="data.state == 1" style="color:red">{{stateName[data.state]}}</span>
						<span v-if="data.state == 2" style="color:green">{{stateName[data.state]}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="创建人"
					name="create_user_realname"
					width="130"
				></c-table-column>
				
				<c-table-column
					label="创建时间"
					name="create_date"
					width="150"
				></c-table-column>

				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="120"
				>
					<template v-slot="{data}">
						<c-table-button power="b_prohibited_words_edit" @click="edit(data)">编辑</c-table-button>
                        <c-table-button power="b_prohibited_words_edit" v-if="data.state == 2" @click="editWordState(1,data)">禁用</c-table-button>
                        <c-table-button power="b_prohibited_words_edit" v-if="data.state == 1" @click="editWordState(2,data)">启用</c-table-button>
						<c-table-button power="b_prohibited_words_edit" @click="del(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
		
		<c-dialog ref="uEdit" title="批量新增违禁词" width="300" @resolve="submit">
			<c-form ref="uForm">
				<c-form-item type="input" label="违禁词" name="words" maxlength="20" required></c-form-item>
				<c-form-item type="hidden" name="id"></c-form-item>
			</c-form>
		</c-dialog>

        <c-dialog ref="prohibitedWordsDialog" title="批量添加违禁词" width="600" button-name="确认" @resolve="prohibitedWordsHandle">
            <m-operate>
                <c-button color="m" @click="addNewProhibitedWords()">添加违禁词</c-button>
            </m-operate>
            <c-table ref="wordList" v-model="prohibitedWordsList" height="400" :paging="false">
                <c-table-column
                        label="序号"
                        width="30"
                >
                    <template v-slot="{data}">
                        {{data.index}}
                    </template>
                </c-table-column>

                <c-table-column
                        label="违禁词"
                        width="300"
                >
                    <template v-slot="{data}">
                        <c-input v-model="data.words" width="100%" height="30" maxlength="20"></c-input>
                    </template>
                </c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="60"
                >
                    <template v-slot="row">
                        <c-table-button @click="row.remove()">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </c-dialog>

    </page>
</template>

<script>
	export default {
		name: 'm_prohibited_words',
		
		data() {
			return {
				stateName: {
					1: '禁用',
					2: '启用'
				},
				state: [
                    {name: '禁用',value: "1"},
                    {name: '启用',value: "2"}
				],
                prohibitedWordsList:[]
			}
		},
		
		mounted() {
			this.$refs.search.search();
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/prohibited/words/list',
					data
				});
			},
            //添加新的违禁词
            batchAddProhibitedWords(){
                this.prohibitedWordsList = [];
                this.$refs.prohibitedWordsDialog.open();
                for (var i=0;i<5;i++){
                    let obj = {
                        index:(i+1),
                        words:''
                    };
                    this.prohibitedWordsList.push(obj);
                }
            },
            //添加新的违禁词
            addNewProhibitedWords(){
                let obj = {
                    index:this.prohibitedWordsList.length + 1,
                    words:''
                };
                this.prohibitedWordsList.push(obj);
            },
            //提交违禁词数据
            prohibitedWordsHandle(stop) {
                stop();
                var words_list = Array.from(this.prohibitedWordsList, item => {
                    if (item.words && item.words!='')
                        return item.words
                });
                words_list = words_list.filter(item => item);
                if (!words_list || words_list.length == 0){
                    this.$message({
                        text: '请输入违禁词内容',
                        icon: 'fail'
                    });
                    return false;
                }
                var flag = false;
                for (var i=0;i<words_list.length;i++){
                    var obj1 = words_list[i];
                    for (var j=0;j<words_list.length;j++){
                        var obj2 = words_list[j];
                        if (i != j && obj1 && obj2 && obj1!='' && obj2!='' && obj1 == obj2){
                            flag = true;
                        }
                    }
                }
                if (flag){
                    this.$message({
                        text: '存在重复的违禁词数据，请检查',
                        icon: 'fail'
                    });
                    return false;
                }
                this.request({
                    url: '/prohibited/words/add',
                    data: {
                        words_list:words_list
                    },
                    loading: true,
                    success: data => {
                        this.$message({
                            text: '违禁词编辑成功',
                            icon: 'success'
                        });
                        this.$refs.table.update();
                        this.$refs.prohibitedWordsDialog.close();
                    }
                });
            },
            //编辑
			edit(val) {
				this.$refs.uForm.set(val);
				this.$refs.uEdit.open();
			},
            //删除
			del(val) {
				this.$confirm({
					text: '确定删除违禁词【'+val.words+'】吗？',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/prohibited/words/remove',
							data: {id:val.id},
							loading: true,
							success: data => {
								this.$message({
									text: '操作成功',
									icon: 'success'
								});
								this.$refs.table.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},
            //启禁用
            editWordState(state,item) {
                this._auditIds = [];
                var tip = "";
                if (item){
                    tip = state == 2 ? '是否确定启用违禁词？' : '是否确定禁用违禁词';
                    this._auditIds = [];
                    this._auditIds.push(item.id);
                }else {
                    //批量操作
                    var list = this.$refs.table.getRow('selected');
                    if (!list.length) {
                        this.$message({
                            text: '请选择要操作的记录'
                        });
                        return;
                    }
                    var flag = true;
                    list.forEach(function(item, index, array) {
                        if((state == 1 && item.data.state == 1)||(state == 2 && item.data.state == 2)){
                            flag = false;
                        }
                    });

                    if(!flag){
                        this.$message({
                            text: state == 1?'请选择【启用】状态的记录进行禁用操作！':'请选择【禁用】状态的记录进行启用操作'
                        });
                        return false;
                    }
                    tip = state == 2 ? '确定要启用【'+list.length+'】条评价吗？' : '确定要禁用【'+list.length+'】条评价吗';
                    this._auditIds = Array.from(list,item=>{
                        return item.data.id;
                    })
                }

                this.$confirm({
                    text: tip,
                    resolve: () => {
                        this.request({
                            url: '/prohibited/words/state',
                            data: {
                                ids: this._auditIds,
                                state: state
                            },
                            loading: true,
                            success: () => {
                                this.$message({
                                    text: state == 2 ? '启用成功' :'禁用成功',
                                    icon: 'success'
                                });
                                this.$refs.table.update();
                            }
                        });
                    }
                });
            },
            //提交编辑数据
            submit(stop) {
				stop();
				this.$refs.uForm.submit({
					url: '/prohibited/words/edit',
					rule: {
						words: [{
							type: 'empty',
							word: '请输入违禁词内容'
						}]
					},
					dataFormatter: data => {
						return data;
					},
					success:(data,res) => {
						this.$message({
							text: '操作成功',
							icon: 'success'
						});
						this.$refs.table.update();
						this.$refs.uEdit.close();
					},
				});
			}
		}
	}
</script>